

export const projectsData = [

  {
    id: 14,
    projectName: "Earthco Web & Mobile",
    projectDesc:
      "EarthCo(Lawn management Company),a CRM (Web & Mobile) facilitating large number of staff and customers",
    tags: ["React", "React Native", "Node"],
    code: "#",
    demo: "https://app.earthcoapp.com",
    image: require('../assets/png/earthco.png'),
  },
  {
    id: 14,
    projectName: "Ivest Club",
    projectDesc:
      "A crypto based application. The users can manage their Ivest token, convert their ivest tokens to bitcoins and vice versa. Users can also create their membership clubs using their Ivest tokens.",
    tags: ["React", "React Native", "Node"],
    code: "#",
    demo: "https://ivest-club.vercel.app/",
    image: require('../assets/png/ivest.png'),
  },
  {
    id: 13,
    projectName: "Laundry App",
    projectDesc:
      "EarthCo(Lawn management Company),a CRM (Web & Mobile) facilitating large number of staff and customers",
    tags: ["React","Typescripts" ,"Node"],
    code: "#",
    demo: "https://public-two-mu.vercel.app/",
    image: require('../assets/png/laundery.png'),
  },
  {
    id: 15,
    projectName: "Doomfang the eternal hunt",
    projectDesc:
      "Doomfang the eternal hunt game",
    tags: ["Reac Native" ],
    code: "#",
    demo: "#",
    image: require('../assets/png/doomfang.png'),
  },
  // {
  //   id: 15,
  //   projectName: "Lookin Marketplace",
  //   projectDesc:
  //     "A mobile marketplace app connecting users to diverse services with real-time data, seamless chat, AI-powered assistance (LAI), and location-based discovery for an engaging, efficient experience.",
  //   tags: [ "React Native", "Firebase", "Websockets"],
  //   code: "#",
  //   demo: "https://www.getlookin.com/",
  //   image: require('../assets/png/lookin.png'),
  // },
  {
    id: 12,
    projectName: "End Pedocide",
    projectDesc:
      "End pedocide a website dedicated to showcase records of children who have died in all wars, aiming to raise awareness and advocate for the protection of children in conflict zones",
    tags: ["React", "MUI", "Node"],
    code: "#",
    demo: "https://end-pedocide.vercel.app/",
    image: require('../assets/png/endpedocide.png'),
  },

  {
    id: 11,
    projectName: "EUTSOL.ca",
    projectDesc: "It is an inventory management System for a Medical Company,",
    tags: ["React", "C#", "Bootstrap"],
    code: "#",
    demo: "http://eutsol.ca:2021/eut/auth/login",
    image: require('../assets/png/eutsole.png'),
  },
  {
    id: 10,
    projectName: "Livestock Magagement app",
    projectDesc:
      "This project is a web app which  enables farmers to easily manage cattle data, including breed, weight, and vaccination etc",
    tags: ["JavaScript", "Local Storage", "Bootstrap"],
    code: "https://github.com/HannanShehzad/projects.github.io/tree/main/livestockManagment",
    demo: "https://hannanshehzad.github.io/projects.github.io/livestockManagment/index.html",
    image: require('../assets/png/livestock.png'),
  },
  {
    id: 9,
    projectName: "Portfolio",
    projectDesc: "My Portfolio for Freelancing",
    tags: ["JavaScript", "HTML", "Bootstrap"],
    code: "https://github.com/HannanShehzad/projects.github.io/tree/main/portfolioCustomized",
    demo: "https://hannanshehzad.github.io/projects.github.io/portfolioCustomized/index.html",
    image: require('../assets/png/portfolio.png'),
  },

  {
    id: 8,
    projectName: "Website for Restraunt",
    projectDesc: "This project is a frontend of a restaurant web app.",
    tags: ["React", "HTML", "Bootstrap"],
    code: "https://github.com/HannanShehzad/projects.github.io/tree/main/Restaurant",
    demo: "https://hannanshehzad.github.io/projects.github.io/Restaurant/index.html",
    image: require('../assets/png/restaurant.png'),
  },
  {
    id: 7,
    projectName: "Zoo",
    projectDesc: "This project is a frontend of a zoo web app.",
    tags: ["JavaScript", "HTML", "Bootstrap"],
    code: "https://github.com/HannanShehzad/projects.github.io/tree/main/zoo",
    demo: "https://hannanshehzad.github.io/projects.github.io/zoo/index.html",
    image: require('../assets/png/zoo.png'),
  },
  {
    id: 6,
    projectName: "Near Store",
    projectDesc: "This project is a frontend of a Near store Ecommerce store.",
    tags: ["JavaScript", "HTML", "Bootstrap"],
    code: "https://github.com/HannanShehzad/projects.github.io/tree/main/nearstore",
    demo: "https://hannanshehzad.github.io/projects.github.io/nearstore/index.html",
    image: require('../assets/png/nearstore.png'),
  },
  {
    id: 5,
    projectName: "GYMY",
    projectDesc: "This project is a frontend of a GYMY web app.",
    tags: ["React", "JavaScript", "Bootstrap"],
    code: "https://github.com/HannanShehzad/gymy",
    demo: "https://gymy-nine.vercel.app/",
    image: require('../assets/png/gymy.png'),
  },
  {
    id: 4,
    projectName: "Kids School",
    projectDesc: "This project is a frontend of a School web app.",
    tags: ["HTML", "JavaScript", "Bootstrap"],
    code: "https://github.com/HannanShehzad/projects.github.io/tree/main/school",
    demo: "https://hannanshehzad.github.io/projects.github.io/school/index.html",
    image: require('../assets/png/school.png'),
  },
  {
    id: 3,
    projectName: "Real Estate",
    projectDesc: "This project is a frontend of a Real Estate web app.",
    tags: ["HTML", "JavaScript", "Bootstrap"],
    code: "https://github.com/HannanShehzad/projects.github.io/tree/main/realEstate",
    demo: "https://hannanshehzad.github.io/projects.github.io/realEstate/index.html",
    image: require('../assets/png/realestate.png'),
  },
  {
    id: 2,
    projectName: "Fashion Store",
    projectDesc: "This project is a frontend of a Fashion store.",
    tags: ["HTML", "JavaScript", "Bootstrap"],
    code: "https://github.com/HannanShehzad/projects.github.io/tree/main/fashion",
    demo: "https://hannanshehzad.github.io/projects.github.io/fashion/index.html",
    image: require('../assets/png/fasion.png'),
  },
  {
    id: 1,
    projectName: "Premium Hunt store",
    projectDesc: "A fully functional Ecommerse store",
    tags: ["Shopify"],
    // code: '#',
    demo: "https://premiumhunt.shop/",
    image: require('../assets/png/premiumhunt.png'),
  },
];

// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/
